import React from 'react';
import {connect} from 'react-redux'
import axios from 'axios';
import { Link as RouterLink, Link } from 'react-router-dom';
import { SocketUtils } from '../utils/javascriptUtils';
import { TicketPageRole } from '../component/UserPermission';


var _ = require('lodash');

function TicketRepliedRows(data, userProfile, role_path) {

  return (_.map(data, function (i, index){
    return <div style={{borderBottom: "1px solid #ddd"}} key={index}>
        <div className="media-title">
            <Link to={role_path + "/ticket/detail/"+i.id} className="font-weight-semibold">{i.code}</Link>
            <span className="text-muted float-right font-size-sm">{i.updated_date}</span>
          <br/>
          <small className="text-muted">{i.user.email}</small>
        </div>
        <span>{i.title}</span>
      </div>
    })
  )
}

function InvoiceSetupRows(data, userProfile, role_path) {

  return (_.map(data, function (i, index){
    return <div style={{borderBottom: "1px solid #ddd"}} key={index}>
        <div className="media-title">
            <Link to={role_path + "/invoice/detail/"+i.id} className="font-weight-semibold">{i.code}</Link>
          <br/>
        </div>
        <span>{i.title}</span>
      </div>
    })
  )
}

// Thông báo mới sử dụng cho "KH lẻ"
function InvoiceSetupList(invoice_setup_list, userProfile) {
  return (
    <div className="media-body">
      {invoice_setup_list.length > 0 ? InvoiceSetupRows(invoice_setup_list, userProfile) : "Không có đơn hàng mới"}
    </div>
  )
}

class TopBar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fullName: ""
    };
    this.channel = SocketUtils.socketStore();
    this.channel.join();
  }

  socketLiveReload = () => {
    const self = this;
    const { ticketModifyReload } = this.props;
    this.channel.on("crm_ticket_modify", payload => {
      ticketModifyReload();
    })
  }

  componentDidMount() {
    const { ticketModifyReload, invoiceSetupReload } = this.props;
    const self = this;
    this.props.loadUserAsync()
    ticketModifyReload();
    // invoiceSetupReload();
    this.socketLiveReload();
  }

  render() {
    const {signoutAsync, items, userProfile, ticketModify, invoice_setup_data, role_path} = this.props;
    const {fullName} = this.state;
    const number_of_ticket = ticketModify ? _.filter(ticketModify, (item) => item).length : null;
    const number_of_service_setup = items ? _.filter(invoice_setup_data, (i) => i).length : 0;
    return (
      <React.Fragment>
        <div className="navbar navbar-expand-md navbar-dark">
          <div className="navbar-brand">
            <a href="/" className="d-inline-block">
              <img src="/assets/img/lglogo.png" alt="Tadu.cloud"/>
            </a>
          </div>
      
          <div className="d-md-none">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
              <i className="icon-tree5"/>
            </button>
          </div>
      
          <div className="collapse navbar-collapse" id="navbar-mobile">
            <span className="badge ml-md-3 mr-md-auto"> </span>
      
            <ul className="navbar-nav">
              {/* <li className="nav-item">
                <Link to={"/user/message"} className="navbar-nav-link d-flex align-items-center" href="#">
                  <i className="icon-envelop3"></i>
                  &nbsp;
                </Link>
              </li> */}
              {/* <li className="nav-item dropdown">
                <a href="#" className="navbar-nav-link dropdown-toggle caret-0" data-toggle="dropdown" aria-expanded="true">
                  <i className="icon-cart5"></i>
                  <span className="d-md-none ml-2">Đơn hàng cần khởi tạo</span>
                  <span className="badge badge-pill bg-warning-400 ml-auto ml-md-0">{number_of_service_setup}</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right dropdown-content wmin-md-400">
                  <div className="dropdown-content-body dropdown-scrollable">
                    {userProfile && InvoiceSetupList(invoice_setup_data, userProfile)}
                  </div>
                </div>
              </li> */}
              {userProfile && TicketPageRole.isShowNewTicketNotify(userProfile.role) && <a href={role_path + "/ticket/all"} className="nav-item dropdown">
                <span className="navbar-nav-link caret-0">
                  <i className="icon-bubbles4"></i>
                  <span className="d-md-none ml-2">Thông báo</span>
                  <span className="badge badge-pill bg-warning-400 ml-auto ml-md-0">{number_of_ticket}</span>
                </span>
              </a>}
              <li className="nav-item dropdown dropdown-user">
                <a href="#" className="navbar-nav-link d-flex align-items-center dropdown-toggle" data-toggle="dropdown">
                  <i className="icon-user mr-3"></i>
                  <span>{userProfile.full_name}</span>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  {/* <RouterLink className="dropdown-item" to="/user_profile">
                    <i className="icon-user-plus"></i> Thông tin cá nhân
                  </RouterLink> */}

                  {/* <RouterLink className="dropdown-item" to="/change_password">
                    <i className="icon-lock5"></i> Đổi mật khẩu
                  </RouterLink> */}

                  <a href="#" className="dropdown-item" onClick={signoutAsync}>
                    <i className="icon-switch2"></i> Đăng xuất
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


const mapState = state => ({
  items: state.cart && state.cart.items,
  userProfile: state.userProfile.data,
  role_path: state.userProfile.role_path,
  ticketModify: state.messageModify.ticket_data,
  invoice_setup_data: state.messageModify.invoice_setup_data
});

const mapDispatch = (dispatch) => ({
  signoutAsync: () => dispatch.app.signoutAsync(),
  loadUserAsync: () => dispatch.userProfile.loadUserAsync(),
  ticketModifyReload: () => dispatch.messageModify.ticketModifyReload(), 
  invoiceSetupReload: () => dispatch.messageModify.invoiceSetupReload()
});

export default connect(mapState, mapDispatch)(TopBar);